var includes,
  indexOf = [].indexOf;

includes = function(a, b) {
  return a.indexOf(b.toLowerCase()) >= 0;
};

angular.module('gym.invoices').factory('InvoiceFailureReasonService', ["$rootScope", "MessageService", function($rootScope, MessageService) {
  return {
    getFailureReasonTooltipType: function(authorizationMessage) {
      var message;
      if (!authorizationMessage) {
        return null;
      }
      if (indexOf.call($rootScope.gym.payment_providers, 'ezidebit') < 0) {
        return null;
      }
      message = authorizationMessage.toLowerCase();
      switch (false) {
        case !includes(message, 'Only active customers can have payments added to their schedule'):
          return 'only_active_customers';
        case !includes(message, 'For reasons other than insufficient funds'):
          return 'only_active_customers_substitution';
        case !(includes(message, 'lost credit card') || includes(message, 'lost card') || includes(message, 'stolen card')):
          return 'lost_card';
        case !includes(message, 'Do not hono'):
          return 'do_not_honour';
        case !includes(message, 'sufficient funds'):
          return 'insufficient_funds';
        case !includes(message, 'Credit Card Transaction Declined'):
          return 'transaction_declined';
      }
    },
    displayFailureReasonDetails: function(authorizationMessage) {
      var messageParams, type;
      type = this.getFailureReasonTooltipType(authorizationMessage);
      messageParams = {};
      switch (type) {
        case 'only_active_customers':
          messageParams.title = 'Payment failure: Add payment denied (only active customers can have payments)';
          messageParams.message = 'This failure means that the last processed failure was for a non-retriable reason such as expired card, lost/stolen card, declined at bank, or do not honour. To resolve this failure message a new payment method needs to be collected via a waiver and then the payment retried.';
          break;
        case 'only_active_customers_substitution':
          messageParams.title = 'Payment failure: New payment method required';
          messageParams.message = "This customer is currently on permanent hold in the payment provider's system. This may be because the payment method has previously expired, or been reported lost / stolen. You will need to collect a new payment method to continue processing payments for this contact. If your account has access to Waivers, the new payment method must be acquired via a waiver.";
          break;
        case 'lost_card':
          messageParams.title = 'Payment failure: Lost or stolen card';
          messageParams.message = 'This failure means that the card was reported as lost or stolen by the contact. To resolve this failure message you must collect another payment method and retry the payment.';
          break;
        case 'do_not_honour':
          messageParams.title = 'Payment failure: Do not honour';
          messageParams.message = 'This failure means that the bank will not allow the transaction to go through. To resolve this failure you will need to collect a new payment method.';
          break;
        case 'insufficient_funds':
          messageParams.title = 'Payment failure: Insufficient funds';
          messageParams.message = 'This failure means that the payment method does not have sufficient funds for the transaction. To resolve this, the contact must have sufficient funds in their account from 12:01am on the day of transaction. If the contact believes this was in error, they should contact their bank to resolve the issue.';
          break;
        case 'transaction_declined':
          messageParams.title = 'Payment failure: Credit Card Transaction Declined';
          messageParams.message = "This failure means that the transaction was declined by the contact's credit card provider. They must contact their bank for more information. To resolve this error, the contact must request their bank does not decline these payments or you will need to collect a new payment method.";
      }
      if (type) {
        return MessageService.message({
          title: messageParams.title,
          message: messageParams.message,
          displayOkButton: true
        });
      }
    }
  };
}]);
